'use strict';

var React = require('react');
var index_es = require('./index.es-8c72aff8.js');
var useEffectOnce = require('./useEffectOnce-5d273a5b.js');
var Image = require('@swiggy-private/dls-web-core/dist/components/Image');
var styled = require('styled-components');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var WidgetController_widgets_DiscoverMilestonesWidget_type = require('./WidgetController/widgets/DiscoverMilestonesWidget/type.js');
var Button = require('@swiggy-private/dls-web-core/dist/components/Button');
var index_es$1 = require('./index.es-55fa6858.js');
var WidgetControllerContext = require('./WidgetControllerContext-924d4968.js');
require('./DeviceContext-f99d280d.js');
var infoFilled = require('@swiggy-private/dls-web-icons/dist/web/generic/infoFilled');
var GenericIconWeb = require('@swiggy-private/dls-web-icons/dist/GenericIconWeb');
var lottie = require('lottie-web/build/player/lottie_light');
var chevronRight = require('@swiggy-private/dls-web-icons/dist/web/generic/chevronRight');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var lottie__default = /*#__PURE__*/_interopDefaultLegacy(lottie);

const i=e=>{},s={clickEvent:i,impressionEvent:i,screenViewEvent:i,landingSourceEvent:e=>{},dpEvent:e=>{}};Object.assign(Object.assign({},{GTM_CLICK_EVENT:"click",GTM_SCREEN_VIEW_EVENT:"screen-view",GTM_IMPRESSION_EVENT:"impression",GTM_LANDING_EVENT:"landing",GTM_LANDING_SOURCE_EVENT:"landing-source"}),{METRIC_EVENT:"PROMETHEUS_EVENT",ECOMMERCE_EVENT:"ECOMMERCE_EVENT"});const g=(e="")=>e?((Number(e)^16*Math.random())>>Number(e)/4).toString(16):"10000000-1000-4000-8000-100000000000".replace(/[018]/g,g);g();const A=React__default['default'].createContext(s);

const backgroundProgressLine = "#EAEDF2";
const backgroundProgressLineColored = "#F45F6C";
const headingLinearGradient = "linear-gradient(188deg, #F15B6B -18.01%, #F15B6A 28.51%, #F15C42 64.46%, #F89A4B 97.07%)";
const subheadingColor = "#F15C52";
const milestoneProgressLineColor = "#D6DBE6";
const Container = styled__default['default'].div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    paddingTop: theme.spacing.large,
    margin: `0 ${theme.spacing.xSmall}`,
}));
const HeaderText = styled__default['default'](Text.Text)(({ theme }) => ({
    padding: `0 ${theme.spacing.medium}`,
    paddingBottom: theme.spacing.xxSmall,
    WebkitFontSmoothing: "auto",
}));
const RewardBarContainer = styled__default['default'].div({
    display: "flex",
    width: "100%",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "space-between",
});
const VerticalRewardBarContainer = styled__default['default'].div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    paddingLeft: theme.spacing.xSmall,
    paddingRight: theme.spacing.large,
    background: theme.colors[theme.colorMode].background_Primary,
    borderRadius: `${theme.cornerRadius.xLarge} ${theme.cornerRadius.xLarge} 0 0`,
    position: "relative",
    top: "-46px",
}));
const CalloutContainer = styled__default['default'].div({
    width: "100%",
});
const VerticalContainer = styled__default['default'].div(({ theme }) => ({
    display: "flex",
    width: "100%",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: theme.spacing.large,
}));
const RewardBarLottieContainer = styled__default['default'].div({
    position: "relative",
});
const MilestoneProgressLine = styled__default['default'].div(({ theme }) => ({
    border: `${theme.spacing.xxxSmall} solid ${milestoneProgressLineColor}`,
    borderRadius: theme.spacing.xxxSmall,
    flex: 1,
    margin: `-${theme.spacing.small}`,
    marginTop: "-5px",
}), ({ theme, colored }) => colored && {
    border: `${theme.spacing.xxxSmall} solid ${backgroundProgressLineColored}`,
});
const VericalMilestoneProgressLine = styled__default['default'].div(({ theme }) => ({
    border: `${theme.spacing.xxxSmall} solid ${backgroundProgressLine}`,
    borderRadius: theme.spacing.xxxSmall,
    margin: `-${theme.spacing.small}`,
    width: "56px",
    marginTop: theme.spacing.xLarge,
    transform: "rotate(90deg)",
}), ({ theme, colored }) => colored && {
    border: `${theme.spacing.xxxSmall} solid ${backgroundProgressLineColored}`,
});
const TransparentSeparator = styled__default['default'].div(({ theme }) => ({
    width: "100%",
    border: `0.5px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
}));
const ImageCotainer = styled__default['default'].div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: theme.spacing.xSmall,
}));
const TextButtonCotainer = styled__default['default'].div(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: theme.spacing.small,
    marginBottom: "28px",
}));
const pulseAnimation = styled.keyframes `
    0% { opacity: 0.5 }
    100% { opacity: 1; }
`;
const CalloutInfoContainer = styled__default['default'].div(({ theme }) => ({
    padding: theme.spacing.small,
    border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
    borderRadius: theme.cornerRadius.medium,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    margin: `0 ${theme.spacing.xSmall}`,
    marginTop: theme.spacing.small,
    position: "relative",
}));
const CalloutInsideContainer = styled__default['default'].div(() => ({}), styled.css `
        animation: ${pulseAnimation} 0.4s ease-in-out forwards;
    `);
const UpwradArrow = styled__default['default'].div(({ theme }) => ({
    width: "0px",
    height: "0px",
    position: "absolute",
    borderLeft: `9px solid ${theme.colors[theme.colorMode].background_Primary}`,
    borderRight: "6px solid transparent",
    borderTop: `6px solid ${theme.colors[theme.colorMode].background_Primary}`,
    borderBottom: "9px solid transparent",
    transform: "rotate(45deg)",
    boxShadow: `-1px -1px 0px ${theme.colors[theme.colorMode].border_Secondary}`,
    left: "37%",
    bottom: "-21px",
    zIndex: 2,
    borderRadius: `${theme.spacing.xxxSmall} 0 0 0`,
}));
const CalloutHeading = styled__default['default'](Text.Text)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    color: theme.colors[theme.colorMode].text_Low_Emphasis,
    textTransform: "uppercase",
}), ({ isUnlocked }) => isUnlocked && {
    background: headingLinearGradient,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fillColor: "transparent",
});
const CalloutDescription = styled__default['default'](Text.Text)(({ theme, isBehindCurrentMilestone }) => ({
    paddingTop: theme.spacing.xxxSmall,
    color: isBehindCurrentMilestone
        ? theme.colors[theme.colorMode].text_High_Emphasis
        : theme.colors[theme.colorMode].text_Low_Emphasis,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    marginRight: "62px",
}), ({ isUnlocked }) => isUnlocked && {
    color: subheadingColor,
});
const VericalCalloutHeading = styled__default['default'](Text.Text)(() => ({
    display: "flex",
    alignItems: "center",
    textTransform: "uppercase",
}));
const VericalCalloutDescription = styled__default['default'](Text.Text)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    paddingTop: theme.spacing.xxSmall,
}));
const ViewAllText = styled__default['default'](Text.Text)(({ theme }) => ({
    position: "absolute",
    bottom: "14px",
    right: theme.spacing.small,
    display: "flex",
    alignItems: "center",
    color: subheadingColor,
}));
const IconContainer = styled__default['default'].div(({ theme }) => ({
    marginRight: theme.spacing.xxxSmall,
    marginTop: `-${theme.spacing.xxxSmall}`,
    height: theme.spacing.medium,
    width: theme.spacing.medium,
}));
const VerticalIconContainer = styled__default['default'].div(({ theme }) => ({
    height: "52px",
    width: "52px",
    [`&: last-child`]: {
        marginBottom: theme.spacing.large,
    },
}));
const AdditionalIconContainer = styled__default['default'].div(({ theme }) => ({
    marginRight: theme.spacing.xSmall,
}));
const ButtonContainer = styled__default['default'].div(({ theme }) => ({
    marginLeft: theme.spacing.xSmall,
    minWidth: "111px",
}));
const UsedOrExpiredBadge = styled__default['default'](Text.Text)(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
    borderRadius: theme.spacing.xSmall,
    color: theme.colors[theme.colorMode].text_Low_Emphasis,
    padding: `${theme.spacing.xxxSmall} ${theme.spacing.xxSmall}`,
    marginLeft: theme.spacing.xxSmall,
    verticalAlign: "middle",
    display: "inline-block",
    fillColor: theme.colors[theme.colorMode].text_Low_Emphasis,
    WebkitTextFillColor: theme.colors[theme.colorMode].text_Low_Emphasis,
}));
const LottieContainer = styled__default['default'].div({
    height: "72px",
    width: "72px",
});
const AdditionCalloutInfo = styled__default['default'](Text.Text)(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].highlight_Sub,
    margin: `${theme.spacing.medium} ${theme.spacing.small}`,
    display: "flex",
    alignItems: "top",
    borderRadius: theme.cornerRadius.small,
    padding: theme.spacing.xSmall,
}));

const TEXTS = {
    USED: "USED",
    EXPIRED: "EXPIRED",
    VIEW_ALL: "VIEW ALL",
    ORDER_NOW: "Order Now",
};
const ICON_HEIGHT = "16px";
const ICON_WIDTH = "16px";
const HORIZONRTAL_PAGE_ICON_HEIGHT = "52px";
const HORIZONRTAL_PAGE_ICON_WIDTH = "52px";
const LOTTIE_IMG_OPTIONS = {
    width: 72,
    height: 72,
};
const DATA_TESTIDS = {
    REWARD_BAR_MILESTONE_CONTAINER: "discover-milestones-widget-reward-bar-milestone-container-{0}",
    USED_OR_EXPIRED_MILESTONE: "discover-milestones-widget-used-or-expired-milestone",
    VIEW_ALL: "discover-milestones-widget-view-all",
    LOCK_ICON: "discover-milestones-widget-lock-icon",
};
const A11Y_TEXTS = {
    MILESTONE_STATE: "{0}, {1}",
    UNLOCKED_MILESTONE: "Keep ordering to unlock this milestone",
    USED_MILESTONE: "You have used this milestone",
    EXPIRED_MILESTONE: "This milestone has expired",
    LOCKED_MILESTONE: "Keep ordering to unlock this milestone",
    VIEW_ALL: "Click to view all milestones in detail",
};
const EVENT_TYPES = {
    MILESTONE_IMPRESSION: "habit_formation_widget_impression",
    VIEW_DETAIL_PAGE_IMPRESSION: "habit_formation_widget_view_reward",
    MILESTONE_CLICK: "habit_formation_widget_benifit_click",
    MILESTONE_ADDITIONAL_INFO_IMPRESSION: "habit_formation_order_indelivery",
};
const REWARD_PAGE_SCREEN_NAME = "reward-page";
const REWARD_PAGE_OBJECT_NAMES = {
    IMPRESSION: "habit_formation_impression",
    CLICK_OREDER_NOW: "habit_formation_order_cta_click",
    GO_BACK: "go-back",
};
const LOCK_ICON_REWARD_INFO = "/Habit_Forming/Lock-icon-3X.png";

const VerticalMilestoneIcon = ({ milestones, currentStateIndex, index, totalRewards, }) => {
    var _a;
    return (React__default['default'].createElement(ImageCotainer, null,
        React__default['default'].createElement(VerticalIconContainer, null,
            React__default['default'].createElement(Image.Image, { height: HORIZONRTAL_PAGE_ICON_HEIGHT, width: HORIZONRTAL_PAGE_ICON_WIDTH, src: index_es.D(((_a = milestones.animationInfo) === null || _a === void 0 ? void 0 : _a.icon) || "") })),
        index !== totalRewards - 1 && (React__default['default'].createElement(VericalMilestoneProgressLine, { colored: index <= +currentStateIndex - 2 }))));
};
var VerticalMilestoneIcon$1 = React.memo(VerticalMilestoneIcon);

const getA11yMilestoneText = (thisMilestone, index, currIdx) => {
    const isCurrentMilestone = index === +currIdx - 1;
    const isUnlocked = isCurrentMilestone && thisMilestone.state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_UNLOCKED;
    const isUsed = isCurrentMilestone && thisMilestone.state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_USED;
    const isExpired = isCurrentMilestone && thisMilestone.state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_EXPIRED;
    const isLocked = !isCurrentMilestone && thisMilestone.state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_LOCKED;
    if (isUnlocked) {
        return index_es.O(A11Y_TEXTS.UNLOCKED_MILESTONE);
    }
    if (isUsed) {
        return index_es.O(A11Y_TEXTS.USED_MILESTONE);
    }
    if (isExpired) {
        return index_es.O(A11Y_TEXTS.EXPIRED_MILESTONE);
    }
    if (isLocked) {
        return index_es.O(A11Y_TEXTS.LOCKED_MILESTONE);
    }
    return "";
};
const getBadgeText = (status) => {
    if (status === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_USED) {
        return TEXTS.USED;
    }
    if (status === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_EXPIRED) {
        return TEXTS.EXPIRED;
    }
    return undefined;
};

const VerticalMilestoneCallout = ({ milestone, index, totalMilestones, currentStateIndex, }) => {
    var _a, _b, _c, _d;
    const { sdk } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    const { clickEvent } = React.useContext(A);
    const onOrderNowClick = React.useCallback(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (((_a = milestone.callout) === null || _a === void 0 ? void 0 : _a.cta) && sdk) {
            clickEvent({
                category: REWARD_PAGE_SCREEN_NAME,
                action: REWARD_PAGE_OBJECT_NAMES.CLICK_OREDER_NOW,
                context: JSON.stringify({
                    milestone: index,
                    benifit_header: milestone.callout.heading,
                    benifit_footer: milestone.callout.description,
                    cta_text: (_c = (_b = milestone.callout) === null || _b === void 0 ? void 0 : _b.cta) === null || _c === void 0 ? void 0 : _c.text,
                }),
            });
            const navigateData = {
                type: ((_e = (_d = milestone.callout) === null || _d === void 0 ? void 0 : _d.cta) === null || _e === void 0 ? void 0 : _e.type) || index_es$1.N.DEEPLINK,
                link: ((_g = (_f = milestone.callout) === null || _f === void 0 ? void 0 : _f.cta) === null || _g === void 0 ? void 0 : _g.link) || "",
            };
            sdk.navigateToScreen(navigateData).catch(() => undefined);
        }
    }, [
        clickEvent,
        index,
        milestone.callout.cta,
        milestone.callout.description,
        milestone.callout.heading,
        sdk,
    ]);
    const isUnlocked = index <= +currentStateIndex - 1;
    const badgeText = getBadgeText(milestone.state);
    return (React__default['default'].createElement(CalloutContainer, null,
        React__default['default'].createElement(TextButtonCotainer, null,
            React__default['default'].createElement("div", null,
                React__default['default'].createElement(VericalCalloutHeading, { isUnlocked: !isUnlocked, variant: "discount_Header_H2", color: !isUnlocked ? "text_Low_Emphasis" : "text_High_Emphasis" },
                    milestone.callout.heading,
                    " ",
                    badgeText && (React__default['default'].createElement(UsedOrExpiredBadge, { variant: "discount_Subheader_S2" }, getBadgeText(milestone.state)))),
                React__default['default'].createElement(VericalCalloutDescription, { isPadding: true, isUnlocked: !isUnlocked, variant: "body_B2_Med", color: !isUnlocked ? "text_Low_Emphasis" : "text_Med_Emphasis" }, milestone.callout.description)),
            ((_b = (_a = milestone.callout) === null || _a === void 0 ? void 0 : _a.cta) === null || _b === void 0 ? void 0 : _b.text) && (React__default['default'].createElement(ButtonContainer, null,
                React__default['default'].createElement(Button.Button, { variant: "secondary", buttonSize: "medium", onClick: onOrderNowClick }, (_d = (_c = milestone.callout) === null || _c === void 0 ? void 0 : _c.cta) === null || _d === void 0 ? void 0 : _d.text)))),
        index + 1 !== totalMilestones && React__default['default'].createElement(TransparentSeparator, null)));
};
var VerticalMilestoneCallout$1 = React.memo(VerticalMilestoneCallout);

const VericalRewardStage = ({ milestones, currentStateIndex, }) => {
    const totalRewards = milestones.length;
    const { impressionEvent } = React.useContext(A);
    const getAnalyticsContext = React.useCallback(() => {
        return milestones.map((milestone) => {
            var _a, _b;
            return {
                unlocked: milestone.state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_UNLOCKED,
                benifit_header: (_a = milestone.callout) === null || _a === void 0 ? void 0 : _a.heading,
                benifit_footer: (_b = milestone.callout) === null || _b === void 0 ? void 0 : _b.description,
                benifit_used: milestone.state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_USED,
                expired: milestone.state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_EXPIRED,
            };
        });
    }, [milestones]);
    useEffectOnce.useEffectOnce(() => {
        impressionEvent({
            category: REWARD_PAGE_SCREEN_NAME,
            action: REWARD_PAGE_OBJECT_NAMES.IMPRESSION,
            context: JSON.stringify(getAnalyticsContext()),
        });
    });
    return (React__default['default'].createElement(VerticalRewardBarContainer, null, milestones.map((thisMilestone, index) => (React__default['default'].createElement(VerticalContainer, null,
        React__default['default'].createElement(VerticalMilestoneIcon$1, { currentStateIndex: currentStateIndex, index: index, milestones: thisMilestone, totalRewards: totalRewards }),
        React__default['default'].createElement(VerticalMilestoneCallout$1, { currentStateIndex: currentStateIndex, milestone: thisMilestone, index: index, totalMilestones: milestones.length }))))));
};
var VericalRewardStage$1 = React.memo(VericalRewardStage);

const Lottie = ({ domLoadedEventHandler, lottiePath, animationData, runAnimation, }) => {
    const lottieElement = React.useRef(null);
    React.useEffect(() => {
        if (lottieElement.current) {
            const anim = lottie__default['default'].loadAnimation(Object.assign({ container: lottieElement.current, renderer: "svg", autoplay: runAnimation, loop: false, rendererSettings: {
                    imagePreserveAspectRatio: "xMidYMid slice",
                    viewBoxOnly: true,
                } }, (animationData ? { animationData } : { path: lottiePath })));
            anim.addEventListener("DOMLoaded", () => domLoadedEventHandler && domLoadedEventHandler(anim));
            return () => anim.destroy();
        }
        return () => { };
    }, [runAnimation, domLoadedEventHandler, animationData, lottiePath]);
    return React__default['default'].createElement(LottieContainer, { ref: lottieElement });
};
var MilestoneLottie = React.memo(Lottie);

const RewardBar = ({ milestones, currentMilestoneIndex, handleCurruntIndexChange, animationType, currentStateIndex, screenName, headerText, }) => {
    const { clickAnalytics } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    const getLottiePath = (thisMilestone, index, type) => {
        var _a, _b;
        let lottiePath = ((_a = thisMilestone.animationInfo) === null || _a === void 0 ? void 0 : _a.lottie) || "";
        if (type === WidgetController_widgets_DiscoverMilestonesWidget_type.AnimationType.ANIMATION_TYPE_MILESTONE_UNLOCKED &&
            +currentStateIndex - 1 === index) {
            lottiePath = ((_b = thisMilestone.animationInfo) === null || _b === void 0 ? void 0 : _b.unlockedLottie) || "";
        }
        return index_es.x(lottiePath, LOTTIE_IMG_OPTIONS, {
            useImageKit: true,
        });
    };
    const clickHandler = (index) => () => {
        if (!index_es.N(clickAnalytics)) {
            const currIndex = +index - 1;
            clickAnalytics({
                action: EVENT_TYPES.MILESTONE_CLICK,
                category: screenName,
                context: {
                    milestone: index,
                    benifit_header: headerText,
                    benifit_footer: `${milestones[currIndex].callout.heading} ${milestones[currIndex].callout.description}}`,
                    benifit_used: milestones[currIndex].state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_USED,
                    benifit_unlocked: milestones[currIndex].state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_UNLOCKED,
                },
            });
        }
        handleCurruntIndexChange(index);
    };
    const totalRewards = milestones.length;
    return (React__default['default'].createElement(RewardBarContainer, null, milestones.map((thisMilestone, index) => (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement(RewardBarLottieContainer, { "data-testid": index_es.O(DATA_TESTIDS.REWARD_BAR_MILESTONE_CONTAINER, index), onClick: clickHandler(index + 1), "aria-label": getA11yMilestoneText(thisMilestone, index, currentMilestoneIndex) },
            React__default['default'].createElement(MilestoneLottie, { runAnimation: currentMilestoneIndex - 1 === index, lottiePath: getLottiePath(thisMilestone, index, animationType) }),
            currentMilestoneIndex - 1 === index && React__default['default'].createElement(UpwradArrow, null)),
        index !== totalRewards - 1 && (React__default['default'].createElement(MilestoneProgressLine, { colored: index <= +currentStateIndex - 2 })))))));
};
var RewardBar$1 = React.memo(RewardBar);

const RewardInfo = ({ milestones, currentMilestone, viewAllClick, screenName, headerText, currentStateIndex, }) => {
    const { impressionAnalytics } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    React.useEffect(() => {
        if (!index_es.N(impressionAnalytics)) {
            const currMilestone = currentMilestone - 1;
            impressionAnalytics({
                action: EVENT_TYPES.MILESTONE_IMPRESSION,
                category: screenName,
                context: {
                    milestone: currentMilestone,
                    benifit_header: headerText,
                    benifit_footer: `${milestones[currMilestone].callout.heading} ${milestones[currMilestone].callout.description}}`,
                    benifit_used: milestones[currMilestone].state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_USED,
                    benifit_unlocked: milestones[currMilestone].state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_UNLOCKED,
                },
            });
        }
    }, [currentMilestone, headerText, impressionAnalytics, milestones, screenName]);
    return (React__default['default'].createElement(React__default['default'].Fragment, null, milestones.map((thisMilestone, index) => {
        if (currentMilestone - 1 === index) {
            const isCurrentMilestoneUnlocked = index === +currentStateIndex - 1;
            const isBehindCurrentMilestone = index <= +currentStateIndex - 1;
            const isUnlocked = isCurrentMilestoneUnlocked &&
                thisMilestone.state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_UNLOCKED;
            const isLocked = !isCurrentMilestoneUnlocked &&
                thisMilestone.state === WidgetController_widgets_DiscoverMilestonesWidget_type.MilestoneState.MILESTONE_STATE_LOCKED;
            const badgeText = getBadgeText(thisMilestone.state);
            return (React__default['default'].createElement(CalloutInfoContainer, { "aria-label": index_es.O(A11Y_TEXTS.MILESTONE_STATE, thisMilestone.callout.heading, thisMilestone.callout.description), key: `${thisMilestone.state}_${index}` },
                React__default['default'].createElement(CalloutInsideContainer, null,
                    React__default['default'].createElement(CalloutHeading, { isUnlocked: isUnlocked, variant: "discount_Header_H2" },
                        isLocked && (React__default['default'].createElement(IconContainer, { "data-testid": DATA_TESTIDS.LOCK_ICON },
                            React__default['default'].createElement(Image.Image, { height: ICON_HEIGHT, width: ICON_WIDTH, src: index_es.D(LOCK_ICON_REWARD_INFO, {
                                    width: +ICON_WIDTH,
                                    height: +ICON_HEIGHT,
                                }, {
                                    useImageKit: true,
                                }) }))),
                        React__default['default'].createElement(Text.Text, { variant: "discount_Header_H2", color: isBehindCurrentMilestone
                                ? "text_High_Emphasis"
                                : "text_Low_Emphasis" }, thisMilestone.callout.heading),
                        badgeText && (React__default['default'].createElement(UsedOrExpiredBadge, { "data-testid": DATA_TESTIDS.USED_OR_EXPIRED_MILESTONE, variant: "discount_Subheader_S2" }, badgeText))),
                    React__default['default'].createElement(CalloutDescription, { isUnlocked: isUnlocked, isBehindCurrentMilestone: isBehindCurrentMilestone, variant: "body_B2_Med" }, thisMilestone.callout.description),
                    React__default['default'].createElement(ViewAllText, { "data-testid": DATA_TESTIDS.VIEW_ALL, variant: "discount_Header_H4", onClick: viewAllClick, "aria-label": A11Y_TEXTS.VIEW_ALL },
                        TEXTS.VIEW_ALL,
                        " ",
                        React__default['default'].createElement(GenericIconWeb.GenericIcon, { fillColor: "primary", Icon: chevronRight.Svg12 })))));
        }
        return null;
    })));
};
var RewardInfo$1 = React.memo(RewardInfo);

const DiscoverMilestoneWidget = (props) => {
    const { currentStateIndex, headerText, milestones, screenName, callout } = props;
    const [currentIndex, updateCurrentIndex] = React__default['default'].useState(+currentStateIndex);
    const { sdk, impressionAnalytics, clickAnalytics } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    const additionalInfo = React.useMemo(() => {
        var _a;
        return (_a = milestones[currentIndex - 1]) === null || _a === void 0 ? void 0 : _a.additionalCallout;
    }, [milestones, currentIndex]);
    const openDetailsScreen = () => {
        var _a;
        try {
            if (clickAnalytics) {
                clickAnalytics({
                    action: EVENT_TYPES.VIEW_DETAIL_PAGE_IMPRESSION,
                    category: screenName,
                });
            }
            sdk === null || sdk === void 0 ? void 0 : sdk.navigateToScreen({
                type: index_es$1.N.DEEPLINK,
                link: ((_a = callout.cta) === null || _a === void 0 ? void 0 : _a.link) || "",
            });
        }
        catch (_b) {
        }
    };
    React.useEffect(() => {
        if ((additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.description) && !index_es.N(impressionAnalytics)) {
            impressionAnalytics({
                action: EVENT_TYPES.MILESTONE_ADDITIONAL_INFO_IMPRESSION,
                category: screenName,
                context: {
                    text: additionalInfo.description,
                },
            });
        }
    }, [additionalInfo, impressionAnalytics, screenName]);
    if (currentStateIndex === "0" || +currentStateIndex > milestones.length) {
        return null;
    }
    return (React__default['default'].createElement(Container, null,
        headerText && React__default['default'].createElement(HeaderText, { variant: "body_B1_Bold" }, headerText),
        React__default['default'].createElement(RewardBar$1, Object.assign({}, props, { handleCurruntIndexChange: updateCurrentIndex, currentMilestoneIndex: currentIndex })),
        React__default['default'].createElement(RewardInfo$1, Object.assign({}, props, { currentMilestone: currentIndex, viewAllClick: openDetailsScreen })),
        (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.description) && (React__default['default'].createElement(AdditionCalloutInfo, { color: "highlight", variant: "body_B3_Med" },
            React__default['default'].createElement(AdditionalIconContainer, null,
                React__default['default'].createElement(GenericIconWeb.GenericIcon, { fillColor: "highlight", Icon: infoFilled.Svg16 })),
            " ",
            additionalInfo.description))));
};
var DiscoverMilestoneWidget$1 = React.memo(DiscoverMilestoneWidget);

const DiscoverMilestoneWidgetWrapper = (props) => {
    const { viewType } = props;
    switch (viewType) {
        case WidgetController_widgets_DiscoverMilestonesWidget_type.DiscoverMilestoneWidgetViewType.DISCOVER_MILESTONE_WIDGET_VIEW_TYPE_HORIZONTAL:
            return React__default['default'].createElement(DiscoverMilestoneWidget$1, Object.assign({}, props));
        case WidgetController_widgets_DiscoverMilestonesWidget_type.DiscoverMilestoneWidgetViewType.DISCOVER_MILESTONE_WIDGET_VIEW_TYPE_VERTICAL:
            return React__default['default'].createElement(VericalRewardStage$1, Object.assign({}, props));
        default:
            return null;
    }
};
var DiscoverMilestoneWidgetWrapper$1 = React.memo(DiscoverMilestoneWidgetWrapper);

exports.DiscoverMilestoneWidgetWrapper = DiscoverMilestoneWidgetWrapper$1;
//# sourceMappingURL=DiscoverMilestoneWidgetWrapper-9009a8bc.js.map
